var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "li",
    { staticClass: "mku-submenu" },
    [
      _c(
        "div",
        {
          staticClass: "mku-submenu-title",
          on: { click: _vm.updateOpenState }
        },
        [_vm._t("title"), _vm._v(" "), _c("i", { class: _vm.iconArrowClasss })],
        2
      ),
      _vm._v(" "),
      _c(
        "mku-collapse-transition",
        {
          attrs: {
            duration: _vm.transitionDuration,
            animate: _vm.transitionAnimate
          }
        },
        [
          _c(
            "ul",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: _vm.isOpen,
                  expression: "isOpen"
                }
              ]
            },
            [_vm._t("default")],
            2
          )
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }